import useNotification from '@/services/useNotification'

const { showErrorNotification } = useNotification()

export default {
  install(app) {
    const tawk = {
      inited: false,
      tawkApi: {},
      setUser({ name, email }) {
        window.Tawk_API = window.Tawk_API || {}
        window.Tawk_API.onLoad = () => {
          window.Tawk_API.setAttributes(
            {
              name,
              email
            },
            (error) => {
              if (error) {
                showErrorNotification(error)
              }
            }
          )
        }
      },
      toggleChat() {
        window.Tawk_API.toggle()
      },
      async init(tawkSettings) {
        if (!this.inited) {
          await this.loadScript(tawkSettings)
          this.setUser(tawkSettings)
          this.inited = true
        }
      },
      loadScript({ widgetId, accountKey }) {
        return new Promise((resolve) => {
          const script = document.createElement('script')
          script.async = true
          script.src = `https://embed.tawk.to/${accountKey}/${widgetId}`
          const firstScript = document.getElementsByTagName('script')[0]
          firstScript.parentNode.insertBefore(script, firstScript)
          script.onload = resolve
        })
      }
    }

    app.config.globalProperties.$tawk = tawk
    app.provide('tawk', tawk)
  }
}
